export default __webpack_public_path__ + "static/media/Claymore of the Archaeologian.60389a10.jpg";